$.fn.EmailComposer = function(object_data)
{
	var _mail = this;
	_mail.object_data = object_data;

	/* Submit form */
	_mail.send = function()
	{
		// close window
		_mail.modal('hide');

		// gather data
		var values = _mail.serializeArray(),
		request = new FormData(),
		data = {};

		// build request
		request.append("model", "mailer");
		$.map(values, function(n, i){
			if (n['name'] == "mailer_action"){
				request.append("action", n['value']);
			} else if (n['name'] == 'mailer_email' || n['name'] == 'mailer_attachments'){
				if (data[n['name']] == undefined){
					data[n['name']] = [];
				}
				data[n['name']].push(n['value']);
			} else {
				if (data[n['name']] != undefined){
					if (typeof data[n['name']] != "array"){
						data[n['name']] = [data[n['name']]];
					}
					data[n['name']].push(n['value']);
				} else {
					data[n['name']] = n['value'];
				}
			}
		});
		request.append("data", JSON.stringify(data));

		// add request to queue
		$.slr.db.add(request);
		return false;
	};

	return function()
	{
		// populate invoice data
		if (_mail.data("model") == "invoice"){
			_mail.find("input.email-placeholder").val(_mail.object_data.contact_email);
			_mail.find("input.filename-placeholder").val(_mail.object_data.str_id + ".pdf");
			_mail.find("input[name=mailer_subject]").val('La facture ' + _mail.object_data.str_id + ' est disponible');
			_mail.find("input[name=mailer_invoice_id]").val(_mail.object_data.id);
			_mail.find('.btn-action-email-send').prop("disabled", false)
		} else if (_mail.data("model") == "contact"){
			_mail.find("input[name=mailer_contact_id]").val(_mail.object_data.id);
			if (_mail.find("input[name=mailer_action]").val() == "send-contact"){
				_mail.find("input[name=mailer_subject]").val(_mail.object_data.contact_subject);
				var select = _mail.find('select[name=mailer_attachments]'),
					attachments = JSON.parse(_mail.object_data.contact_attachments);
				select.append($('<option>').attr("value", "pdf").text(_mail.object_data.contact_attachment).prop("selected", true));
				attachments.forEach(function(attachment, index){
					select.append($('<option>').attr("value", attachment.id).text(attachment.file_name).prop("selected", false));
				});
			} else if (_mail.find("input[name=mailer_action]").val() == "send-coords"){
				_mail.find("input[name=mailer_subject]").val(_mail.object_data.coords_subject);
				_mail.find("input.filename-placeholder").val(_mail.object_data.coords_attachment);
			}
		}

		// tag emails
		_mail.find('select.tags').select2({
			tags: true,
			tokenSeparators: [',', ' '],
			selectOnClose: true,
			dropdownCss: {display: 'none'},
		}).on("change", function(){
			_mail.find('.btn-action-email-send').prop("disabled", $(this).val().length ? false : true);
		});
		setTimeout(function(){
			_mail.find('select.tags').parent().find("input.select2-search__field").attr("placeholder", "Ajouter une adresse courriel");
		}, 100);

		// attachments
		_mail.find('select.attachments').select2({
			tags: true,
			tokenSeparators: [',', ' '],
			selectOnClose: true,
		});

		// click action, disabled until an email address is tagged
		_mail.find('.btn-action-email-send').on("click", _mail.send).prop("disabled", _mail.find('select.tags').length > 0);
		return _mail;
	}();
};


$.fn.EmailComposerMultiple = function(_list)
{
	var _mail_multiple = this;
	_mail_multiple.ids = [];
	_mail_multiple.str_ids = [];
	_mail_multiple.email_addresses = [];

	/* On changed: ids changed */
	_mail_multiple.ids_changed = function(e)
	{
		var $target = $(e.target);
		if ($target.attr("name") == "send_multiple"){
			var id = parseInt($target.val(), 10),
			str_id = $target.data("string-id"),
			email_address = $target.data("email");
			if ($target.is(":checked")){
				_mail_multiple.ids.push(id);
				_mail_multiple.str_ids.push(str_id);
				_mail_multiple.email_addresses.push(email_address);
			} else {
				_mail_multiple.ids.splice(_mail_multiple.ids.indexOf(id), 1);
				_mail_multiple.email_addresses.splice(_mail_multiple.str_ids.indexOf(str_id), 1);
				_mail_multiple.str_ids.splice(_mail_multiple.str_ids.indexOf(str_id), 1);
			}
		}
	};

	/* Open */
	_mail_multiple.open = function()
	{
		// must select items first
		if (!_mail_multiple.ids.length){
			$.slr.notify({
				icon: 'fa fa-warning',
				title: 'Aucune facture sélectionnée',
				message: "Vous devez d'abord sélectionner une ou plusieurs factures dans la liste."
			}, { type: 'danger' });
			return false;
		}

		// must have exactly one email address
		if (_mail_multiple.email_addresses.length > 1){
			var first_address = _mail_multiple.email_addresses[0];
			for (var i = 1; i < _mail_multiple.email_addresses.length; i++) {
				var address = _mail_multiple.email_addresses[i];
				if (address != first_address){
					$.slr.notify({
						icon: 'fa fa-warning',
						title: 'Plusieurs adresses sélectionnées',
						message: "Les factures sélectionnées doivent obligatoiremenet être associées à la même adresse courriel."
					}, { type: 'danger' });
					return false;
				}
			}
		}

		// set form info
		_mail_multiple.find("input[name=mailer_email]").val(_mail_multiple.email_addresses[0]);
		_mail_multiple.find("input[name=mailer_invoices_ids]").val(_mail_multiple.ids.join(','));
		_mail_multiple.find("input[name=mailer_str_ids]").val(_mail_multiple.str_ids.join(', '));

		// open the modal window
		_mail_multiple.modal('show');
	};

	/* Submit form */
	_mail_multiple.send = function()
	{
		// close window
		_mail_multiple.modal('hide');

		// gather data
		var values = _mail_multiple.serializeArray(),
		request = new FormData(),
		data = {};

		// build request
		request.append("model", "mailer");
		$.map(values, function(n, i){
			if (n['name'] == "mailer_action"){
				request.append("action", n['value']);
			} else {
				if (data[n['name']] != undefined){
					if (typeof data[n['name']] != "array"){
						data[n['name']] = [data[n['name']]];
					}
					data[n['name']].push(n['value']);
				} else {
					data[n['name']] = n['value'];
				}
			}
		});
		request.append("data", JSON.stringify(data));

		// add request to queue
		$.slr.db.add(request);
		return false;
	};

	return function()
	{
		$("table.dataTable").on("change", _mail_multiple.ids_changed);
		$('.btn-action-email-multiple').on("click", _mail_multiple.open);
		_mail_multiple.find('.btn-action-email-send').on("click", _mail_multiple.send);
		return _mail_multiple;
	}();
};


$.fn.InvoiceSelector = function(_list)
{
	var _invoice_multiple = this;
	_invoice_multiple.ids = [];
	_invoice_multiple.str_ids = [];

	/* On changed: ids changed */
	_invoice_multiple.ids_changed = function(e)
	{
		var $target = $(e.target);
		if ($target.attr("name") == "send_multiple"){
			var id = parseInt($target.val(), 10),
			str_id = $target.data("string-id")
			if ($target.is(":checked")){
				_invoice_multiple.ids.push(id);
				_invoice_multiple.str_ids.push(str_id);
			} else {
				_invoice_multiple.ids.splice(_invoice_multiple.ids.indexOf(id), 1);
				_invoice_multiple.str_ids.splice(_invoice_multiple.str_ids.indexOf(str_id), 1);
			}
		}
		if (_invoice_multiple.ids.length) {
			$('button.rapport-a-payer, button.code-paiement').prop('disabled', false)
		} else {
			$('button.rapport-a-payer, button.code-paiement').prop('disabled', true)
		}
	};

	_invoice_multiple.send = function() {
		_invoice_multiple.attr('action', _invoice_multiple.attr('action').replace('code', 'a-payer'))
		_invoice_multiple.find("input[name=selection]").val(_invoice_multiple.ids.join(','));
		_invoice_multiple.submit();
	}

	_invoice_multiple.code = function() {
		_invoice_multiple.attr('action', _invoice_multiple.attr('action').replace('a-payer', 'code'))
		_invoice_multiple.find("input[name=selection]").val(_invoice_multiple.ids.join(','));
		_invoice_multiple.submit();
		setTimeout(function () {
			location.reload()
		}, 1000)
	}

	return function()
	{
		$("table.dataTable").on("change", _invoice_multiple.ids_changed);
		$('button.rapport-a-payer').on("click", _invoice_multiple.send);
		$('button.code-paiement').on("click", _invoice_multiple.code);
		return _invoice_multiple;
	}();
};
